import { LabelWithMessage } from '@common/LabelWithMessage';
import { createTableDefaultColumn } from '@common/tableColumn.services';
import { Column, createTableCell, createTableColumn, Grid, ResponsivePaginatedTable } from '@gcl/react-core';
import { getNextAction } from '@permitToLoadRemove/permitToLoadRemove.hooks';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import React from 'react';
import { IProjectLoadingRemovalCertBase } from './permitToLoadRemoveDetailPage.models';

interface IPermitToLoadRemoveDetailRelatedRemovalCertProps {
  projectRemovalCerts?: IProjectLoadingRemovalCertBase[];
}
export const PermitToLoadRemoveDetailRelatedRemovalCert: React.FunctionComponent<
  IPermitToLoadRemoveDetailRelatedRemovalCertProps
> = ({ projectRemovalCerts }) => {
  const { navigate } = useNavigate();

  const columns = React.useMemo(() => {
    return [
      createTableDefaultColumn<IProjectLoadingRemovalCertBase>(
        'certificateNo',
        'Removal Cert No.',
        ({ value, item }) => {
          navigate(routes.t4.view.path, { id: item.id.toString() });
        },
        ({ item }) => {
          return 'gcl-fl-md';
        },
        ({ item }) => {
          return { cursor: 'pointer' };
        },
      ),
      createTableColumn({
        Header: 'Next Action',
        accessor: 'nextAction',
        Cell: createTableCell<string, any>(
          (value: string, item: IProjectLoadingRemovalCertBase, index: number, cellExtras: { [key: string]: any }) => {
            return <span>{getNextAction(item.status)}</span>;
          },
        ),
      } as Column),
    ];
  }, []);

  if ((projectRemovalCerts?.length ?? 0) <= 0) return null;

  return (
    <Grid item xs={12}>
      <LabelWithMessage labelFor="RelatedRemovalCertificate" text="Related Removal Certificate" />
      <ResponsivePaginatedTable
        disablePagination
        allowSelectRow={false}
        columns={columns}
        items={projectRemovalCerts ?? []}
      />
    </Grid>
  );
};
